export default "__VITE_ASSET__NyzjNYke__"